/**
 * Drop-in replacement for the Lucide `Skull` icon, using the Chillet
 * skeleton mascot artwork. Mirrors the lucide icon API: `size`, `className`,
 * `style` — so existing call sites work unchanged.
 *
 * The image is rendered inside a span so callers can keep using
 * `inline-block`, glow filters, and animations the same way.
 */
export function ChilletSkull({ size = 24, className = "", style = {}, ...rest }) {
  const px = typeof size === "number" ? `${size}px` : size;
  return (
    <span
      data-testid="chillet-skull-icon"
      className={`inline-flex items-center justify-center align-middle ${className}`}
      style={{
        width: px,
        height: px,
        lineHeight: 0,
        ...style,
      }}
      {...rest}
    >
      <img
        src="/chillet_skull.png"
        alt="Chillet skull"
        draggable={false}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          // Avoid color-tint filters: the artwork has its own colors.
          // The parent's `style.filter` (e.g. drop-shadow glow) still applies
          // because filters compose down the tree.
          userSelect: "none",
          pointerEvents: "none",
        }}
      />
    </span>
  );
}

export default ChilletSkull;
